import { useState } from "react";
import { BoldifyReplace } from "./BoldifyReplace";
import ActionTracker from './ActionTracker';

const LairActions = ({ content, label, labelDesc=undefined, actions_count=undefined, handleSlotRecharge=undefined, cKey=undefined, nested = -1 }) => {
    const [collapsed, setCollapsed] = useState(false);

    if (!Array.isArray(content) || content.length === 0) return null;
    let showLargeActionTracker = !!actions_count && !!handleSlotRecharge

    return (
        <>
            {label && (
                <>
                    <h1 className='infoTitle infoTitleCollapse' style={{ cursor: "pointer", userSelect: "none", display: 'flex', alignItems: 'center' }} onClick={() => setCollapsed((c) => !c)}>
                        {label}
                        {/* This is for legendary actions since it goes next to the big title */}
                        {showLargeActionTracker &&
                            <ActionTracker 
                                actions_count={actions_count}
                                cKey={cKey}
                                handleCheck={handleSlotRecharge}
                            />
                        }
                        <div style={{marginLeft: 'auto', cursor: 'pointer'}}>
                            <svg width="16" height="16" viewBox="0 0 16 16" style={{
                                verticalAlign: "middle",
                                transition: "transform 0.2s",
                                transform: collapsed ? "rotate(90deg)" : "rotate(0deg)"
                            }}>
                                <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </h1>
                    <hr className="lineSeperator" />
                </>
            )}

            {!collapsed && // Extra description for this section in non bolded red i.e. legendary actions description
                <>
                    {labelDesc &&
                        <div className='actionInfo'>
                            {labelDesc}
                        </div>
                    }

                    {content.map((contentItem, index) => {
                        if (typeof contentItem === 'string') {
                            if(nested === -1) {
                                // Top level Section description
                                return (
                                    <div className='actionInfo' key={contentItem}>
                                        <BoldifyReplace name={contentItem} />
                                    </div>
                                );
                            } else {
                                // Add extra padding for nested strings inside of entries
                                return (index === 0 ?
                                    <>
                                        <BoldifyReplace desc={contentItem} />
                                    </>
                                    :
                                    <div style={{paddingTop: '4px'}}>
                                        <BoldifyReplace desc={contentItem} />
                                    </div>

                                )
                            }
                        }

                        if (typeof contentItem === 'object') {
                            // content is items | contentItem.type: item | contains contentItem.entries
                            if (contentItem.type === 'list') {
                                return (
                                    <ul className="spellList" key={contentItem.type + nested}>
                                        <LairActions content={contentItem?.items} handleSlotRecharge={handleSlotRecharge} cKey={cKey+"."+index+'.items'} nested={nested + 1}/>
                                    </ul >
                                );
                            } else if(contentItem.type === "table") {
                                return (
                                    <table className='spellTable'>
                                        <tr>
                                            {contentItem.colLabels.map((label) => {
                                                return <th><BoldifyReplace desc={label} /></th>
                                            })}
                                        </tr>
                                        {contentItem.rows.map((row) => {
                                            return (
                                                <tr>
                                                    {row.map((rowData, index) => {
                                                        if(typeof rowData === 'object') {
                                                            if(rowData.roll?.exact)
                                                                return <td className='spellTableDice'>{rowData.roll.exact}</td>
                                                            else 
                                                                return <td className='spellTableDice'>{rowData.roll.min} - {rowData.roll.max}</td>
                                                        } else {
                                                            return <td className={index ? "" : "spellTableDice"}><BoldifyReplace desc={rowData}/></td>
                                                        }
                                                    })}
                                                </tr>
                                            )
                                        })}
                                    </table>
                                )
                            }

                            return (
                                <li className="actionInfo" key={cKey+'.'+index+'.actionItem'}>
                                    {contentItem?.rechargeCount !== 0 && !isNaN(contentItem?.rechargeCount) && handleSlotRecharge ? (
                                        <div className={`actionToken-container`}>
                                            <strong><BoldifyReplace name={contentItem.name} /></strong>
                                            <ActionTracker 
                                                actions_count={contentItem.rechargeCount}
                                                cKey={cKey+'.'+index+'.actionTracker'}
                                                nested={nested}
                                                handleCheck={handleSlotRecharge}
                                                actionIndex={index}
                                            />
                                        </div>
                                    ) : ( 
                                        <><strong><BoldifyReplace name={contentItem.name} /></strong> </>
                                    )}
                                    {contentItem.entry && (
                                        <>
                                            <BoldifyReplace desc={contentItem.entry} />
                                        </>
                                    )}
                                    {contentItem.entries && (
                                        <>
                                            <LairActions content={contentItem.entries} handleSlotRecharge={handleSlotRecharge} cKey={cKey+'.'+index+'.entries'} nested={nested + 1}/>
                                        </>
                                    )}
                                </li>
                            )
                        }

                        // Fallback for unknown types
                        return <div style={{color: "red"}}>Nat 20 Investigation! Seeing this means you found a bug! Please report what Monster statblock this is in the DmBuddy Discord! (Link in the bottom left) </div>;
                    })}
                </>
            }
        </>
    );
};

export default LairActions;